import script from "./PersonalfragenView.vue?vue&type=script&setup=true&lang=js"
export * from "./PersonalfragenView.vue?vue&type=script&setup=true&lang=js"

import "./PersonalfragenView.vue?vue&type=style&index=0&id=6659902d&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6659902d"]])

export default __exports__